import { Button } from "react-bootstrap"
import { usePortPredictorBacktestAPI } from "./usePortPredictorBacktestAPI"

export function Backtest() {
  const { startBacktest } = usePortPredictorBacktestAPI()
  return (
    <Button
      onClick={startBacktest}
      style={{ width: "500px", margin: "2rem", height: "4rem" }}
    >
      START BACKTEST
    </Button>
  )
}
